import { render } from "./modal_listearticletrt.vue?vue&type=template&id=1c52319e&scoped=true"
import script from "./modal_listearticletrt.vue?vue&type=script&lang=js"
export * from "./modal_listearticletrt.vue?vue&type=script&lang=js"

import "./modal_listearticletrt.vue?vue&type=style&index=0&id=1c52319e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c52319e"]])

export default __exports__